<template>
  <div v-if="active" class="notification is-info text-align-left p-3" :class="{ dismissed: notification.dismissed }">
    <div class="d-flex justify-space-between">
      <UpdatingTime class="bold" :time="created_on"/>
      <button v-show="!notification.dismissed" @click="dismiss()" :disabled="dismissing" class="delete"></button>
    </div>
    <div class="flex-space-between">

        <p v-if="ntype == 'col_connected'">You're now connected with {{ notification.user.name || notification.user.email }}</p>

        <div v-else-if="ntype == 'col_request_rec'">
          <p class="mb-1">{{ notification.user.name || notification.user.email }} wants to connect with you</p>
          <button @click="accept(notification.user.id)" class="button is-small is-primary is-outlined" :class="{ 'is-inverted': !notification.dismissed }">Accept</button>
          <button @click="deny(notification.user.id)" class="button is-small is-danger is-outlined" :class="{ 'is-inverted': !notification.dismissed }">Deny</button>
        </div>

        <p v-else-if="ntype == 'col_request_sent'">
          You sent a connection request to {{ notification.user.name || notification.user.email }}
        </p>

        <p v-else-if="ntype === 'group_applied'">
          <span v-if="notification.text">
            You requested to join the group <b>{{ notification.text }}</b>
          </span>
          <span v-else>
            You requested to join an <em>unnamed</em> group.
          </span>
        </p>

        <p v-else-if="ntype === 'group_joined'">
          <span v-if="notification.text">
            You successfully joined the group <b>{{ notification.text }}</b>
          </span>
          <span v-else>
            You successfully joined an <em>unnamed</em> group.
          </span>
        </p>

        <p v-else-if="ntype === 'group_left'">
          <span v-if="notification.text">
            You left the group <b>{{ notification.text }}</b>
          </span>
          <span v-else>
            You successfully left an <em>unnamed</em> group.
          </span>
        </p>

        <p v-else-if="ntype == 'vid_shared'">
          {{ notification.user.name || notification.user.email }} shared a <router-link :to="'/videos/' + notification.video.id" >video</router-link> with you
        </p>

        <p v-else-if="ntype == 'vid_comment'">
          {{ notification.user.name || notification.user.email }} {{ notification.text }} <router-link :to="'/videos/' + notification.video.id" >video</router-link>
        </p>

        <p v-else>{{ notification.text }}</p>
    </div>

  </div>
</template>

<script>
import store from '../store.js'

import UpdatingTime from './UpdatingTime.vue'

export default {
  name: 'Notification',
  props: {
    notification: {
      required: true,
    },
  },
  components: {
    UpdatingTime,
  },
  data () {
    return {
      dismissing: false,
      active: true,
    }
  },
  methods: {
    dismiss () {
      this.dismissing = true
      store.dispatch('dismissNotification', this.notification.id)
        .then(() => {
          this.dismissing = false
        })
    },
    accept (colleagueID) {
      store.dispatch('addColleague', { colleagueID })
        .then(() => {
          this.dismiss
          this.active = false
        })
    },
    deny (colleagueID) {
      store.dispatch('denyColleagueRequest', { colleagueID })
        .then(() => {
          this.dismiss
          this.active = false
        })
    },
  },
  computed: {
    ntype () {
      return this.notification.notification_type
    },
    created_on () {
      return this.notification.created_on
    },
  },
}
</script>

<style lang="scss" scoped>
$blue: #3273dc;

// NOTE: This only works for is-info styled notifications

.notification:not(.dismissed) {
  background-color: $blue;
  animation: glow 3s infinite;
}

.dismissed {
  background-color: whitesmoke;
  color: inherit;
}

@keyframes glow {
  0% {
    background-color: $blue;
  }
  50% {
    background-color: lighten($blue, 10%);
  }
}

// bulma override
.notification:not(:last-child) {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// Notification.vue?04b2df7d